<template>
  <app-page lean>
    <!-- leichter Titel wie die übrigen Seiten (Kundenwunsch 13.10.2026: „jetzt noch profil und kundeneinstellungen
         anpassen“), „Passwort ändern“ als Aktion rechts in der Titelzeile; die Daten als verschachtelte Karte wie im
         Dashboard -->
    <template #actions>
      <app-button icon="lock" @click="openPasswordDialog">Passwort ändern</app-button>
    </template>
    <div class="app-page-pad">
      <app-panel nested class="profile-panel" icon="user" title="Benutzerdaten">
        <div class="profile-head">
          <app-avatar :name="user.fullname || user.username || ''" :size="40" />
          <div class="profile-head__text">
            <span class="profile-head__name">{{ show(user.fullname) }}</span>
            <span class="profile-head__login">{{ show(user.username) }}</span>
          </div>
        </div>
        <dl class="profile-list">
          <dt>Benutzername</dt>
          <dd>{{ show(user.username) }}</dd>
          <dt>Benutzer-ID</dt>
          <dd>{{ show(user.user_id) }}</dd>
          <dt>Name</dt>
          <dd>{{ show(user.fullname) }}</dd>
          <dt>Rolle</dt>
          <dd>{{ show(roleText) }}</dd>
          <dt>Aktiv</dt>
          <dd>{{ yesNo(user.active) }}</dd>
          <dt>Testbenutzer</dt>
          <dd>{{ yesNo(user.is_test_user) }}</dd>
        </dl>
      </app-panel>
    </div>
    <!-- Dialog wie „Mandant wechseln“ (verschachtelte Karte, unscharfer Hintergrund) -->
    <app-dialog v-model="dialog" title="Passwort ändern" persistent blur nested :max-width="480">
      <div class="app-form">
        <div class="app-form-field">
          <label class="app-label" for="profile-new-password">Neues Passwort*</label>
          <app-text-field
            id="profile-new-password"
            v-model="newPassword"
            type="password"
            autocomplete="new-password"
            required
            :error="passwordError"
          />
        </div>
        <div class="app-form-field">
          <label class="app-label" for="profile-new-password-repeat">Neues Passwort wiederholen*</label>
          <app-text-field
            id="profile-new-password-repeat"
            v-model="newPasswordRepeat"
            type="password"
            autocomplete="new-password"
            required
            :error="passwordRepeatError"
          />
        </div>
      </div>
      <template #actions>
        <app-button @click="closePasswordDialog">Abbrechen</app-button>
        <app-button kind="primary" :disabled="!passwordValid" @click="savePassword">Speichern</app-button>
      </template>
    </app-dialog>
  </app-page>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { roleLabel } from "@/shell/navigation";
import { LEER } from "@/utils/format";

// erste verletzte Regel (Vuetify-Muster: Regel liefert true oder den Meldungstext)
function firstRuleError(rules, value) {
  for (let i = 0; i < rules.length; i++) {
    const result = rules[i](value);
    if (result !== true) {
      return typeof result === "string" ? result : true;
    }
  }
  return null;
}

export default {
  data() {
    return {
      dialog: false,
      newPassword: null,
      newPasswordRepeat: null
    };
  },
  computed: {
    ...mapState(["profile"]),
    // null-sicher: zwischen Abmelden und Routenwechsel ist profile null
    user() {
      return this.profile || {};
    },
    // feste Rollenbezeichnung (Spezifikation 3.3), unbekannte Codes als Code
    roleText() {
      return roleLabel(this.user.role) || this.user.role;
    },
    // Meldungen der unveränderten Regeln, sobald im Feld etwas eingegeben wurde
    passwordError() {
      return this.newPassword === null ? null : firstRuleError(this.rules, this.newPassword);
    },
    passwordRepeatError() {
      return this.newPasswordRepeat === null
        ? null
        : firstRuleError(this.rulesRepeat, this.newPasswordRepeat);
    },
    rules() {
      const rules = [];

      const minLengthRule = value =>
        (value || "").length >= 4 ||
        `Das Passwort muss mindestens 4 Zeichen lang sein.`;
      rules.push(minLengthRule);

      return rules;
    },
    // Speichern erst mit gültigem und wiederholtem Passwort (vorher ohne Prüfung gesendet)
    passwordValid() {
      return !!this.newPassword && !!this.newPasswordRepeat
        && firstRuleError(this.rules, this.newPassword) === null
        && firstRuleError(this.rulesRepeat, this.newPasswordRepeat) === null;
    },
    rulesRepeat() {
      const rules = [];

      const samePasswordRule = () =>
        this.newPassword === this.newPasswordRepeat ||
        `Die Passwörter stimmen nicht überein.`;
      rules.push(samePasswordRule);
      return rules;
    }
  },
  methods: {
    show(value) {
      return value === null || value === undefined || value === "" ? LEER : value;
    },
    yesNo(value) {
      if (value === null || value === undefined || value === "") {
        return LEER;
      }
      return Number(value) === 1 ? "Ja" : "Nein";
    },
    openPasswordDialog() {
      this.newPassword = null;
      this.newPasswordRepeat = null;
      this.dialog = true;
    },
    // Felder leeren (vorher blieb das neue Passwort nach „Abbrechen“ und „Speichern“ stehen)
    closePasswordDialog() {
      this.dialog = false;
      this.newPassword = null;
      this.newPasswordRepeat = null;
    },
    async savePassword() {
      if (!this.passwordValid) {
        return;
      }
      const newPassword = this.newPassword;
      this.closePasswordDialog();
      await axios.put(
        `${this.$store.state.baseUrl}password?customer_id=${this.profile.customer_id}&username=${this.profile.username}`,
        { newPassword }
      );
    }
  },
  async mounted() {}
};
</script>

<style scoped>
.profile-panel {
  max-width: 560px;
}
/* Kopf der Karte: Avatar, Name und Benutzername wie im Detailbereich der Benutzer */
.profile-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line-2);
}
.profile-head__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.profile-head__name {
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  color: var(--ink);
}
.profile-head__login {
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}
/* Datenliste wie im Detailbereich der Verkäufe (Spezifikation 4.2.7) */
.profile-list {
  display: grid;
  grid-template-columns: 124px minmax(0, 1fr);
  gap: var(--sp-2) var(--sp-3);
  align-items: baseline;
  max-width: 560px;
  margin: 0;
}
.profile-list dt {
  font-size: 12px;
  line-height: 20px;
  color: var(--ink-3);
}
.profile-list dd {
  margin: 0;
  min-width: 0;
  font-size: 13px;
  line-height: 20px;
  overflow-wrap: anywhere;
}
</style>
